import React, { useCallback, useId } from "react";

import "./benefitArticleCard.scss";
import { FeaturedBenefits, FeaturedBenefitsPlanList } from "../../../../../constants/benefits.constants";
import { useNavigate } from "react-router-dom";

const BenefitArticleCard: React.FC = (): JSX.Element => {
	const navigate = useNavigate();
	const mapId = useId();

	const handleRedirectToPlanPage = useCallback(
		(planType: string, planRoutePage: string) => {
			const redirectionRoute = `/plans/${planType}/${planRoutePage}`;
			navigate(redirectionRoute);
		},
		[navigate]
	);

	return (
		<div className="benefit-article-main-container" id="benefit-article-main-container">
			<h3 className="main-title">Featured Plans</h3>
			{/* <div className="core-line">
				<h2>Core Plans</h2>
				<hr></hr>
			</div> */}
			<div className="grid-container">
				<div className="core-line-in">
					<h2>Core Plans</h2>
					<hr></hr>
				</div>
				{FeaturedBenefitsPlanList.corePlans.map((data: FeaturedBenefits) => {
					const { planType, cardImage, cardTitle, cardDescription, planRedirectionRoute } = data;
					return (
						<div
							className="grid-item-container"
							key={mapId}
							onClick={() => handleRedirectToPlanPage(planType.toLowerCase(), planRedirectionRoute)}
						>
							<div
								className="sponsored-ribbon-wrapper"
								style={
									planType === "CORE"
										? {
												background: "linear-gradient(to right, #f40752, #f9ab8f)"
											}
										: {
												background: "linear-gradient(to right, #a223d1, #4631ce)"
											}
								}
							>
								<div className="glows">&nbsp;</div>
								<span className="ribbon-text">{planType === "CORE" ? "Core Plan" : "VEB Plan"}</span>
								<div className="ribbon-text-support"></div>
							</div>
							<div className="grid-item">
								<img src={cardImage} alt="" />
								<div className="gradient-ribbon" />
								<span className="card-title">{cardTitle}</span>
								<span className="card-description">{cardDescription}</span>
							</div>
						</div>
					);
				})}
			</div>
			{/* VEB */}
			{/* <div className="VEB-line">
				<h2>VEB Plans</h2>
				<hr></hr>
			</div> */}
			<div className="grid-container">
				<div className="VEB-line-in">
					<h2>VEB Plans</h2>
					<hr></hr>
				</div>
				{FeaturedBenefitsPlanList.vebPlans.map((data: FeaturedBenefits) => {
					const { planType, cardImage, cardTitle, cardDescription, planRedirectionRoute } = data;
					return (
						<div
							className="grid-item-container"
							key={mapId}
							onClick={() => handleRedirectToPlanPage(planType.toLowerCase(), planRedirectionRoute)}
						>
							<div
								className="sponsored-ribbon-wrapper"
								style={
									planType === "CORE"
										? {
												background: "linear-gradient(to right, #f40752, #f9ab8f)"
											}
										: {
												background: "linear-gradient(to right, #a223d1, #4631ce)"
											}
								}
							>
								<div className="glows">&nbsp;</div>
								<span className="ribbon-text">{planType === "CORE" ? "Core Plan" : "VEB Plan"}</span>
								<div className="ribbon-text-support"></div>
							</div>
							<div className="grid-item">
								<img src={cardImage} alt="" />
								<div className="gradient-ribbon" />
								<span className="card-title">{cardTitle}</span>
								<span className="card-description">{cardDescription}</span>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default BenefitArticleCard;
